import { useCallback, useState } from "react";

export const useStateTtl = <T>(initialValue: T, tllInSeconds: number) => {
    const [value, setValue] = useState<T>(initialValue);

    const reset = useCallback(() => {
        setValue(initialValue);
    }, [setValue]);

    const setState = useCallback(
        (newValue: T) => {
            setValue(newValue);

            setTimeout(reset, tllInSeconds * 1000);
        },
        [reset, setValue],
    );

    return {
        setState,
        value,
    };
};
